enum UPSELLING_PAYMENTS_STATUSES {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}

enum OFFER_TEMPLATES {
  custom = 'CUSTOM',
  checkIn = 'EARLY_CHECK_IN',
  checkOut = 'LATE_CHECK_OUT',
  waivo1500 = 'WAIVO_PROPERTY_PROTECTION_1500',
  waivo2500 = 'WAIVO_PROPERTY_PROTECTION_2500',
  waivo5000 = 'WAIVO_PROPERTY_PROTECTION_5000',
}

enum OFFER_PRICE_TYPES {
  single = 'SINGLE_PRICE',
  multiple = 'MULTIPLE_PRICE',
  // dateTime = 'DATA_AND_TIME_RANGE_PRICE',
}

enum OFFER_PRICES_FIELD {
  price = 'price',
  unit = 'unit_type',
  name = 'name',
  day = 'day',
}

enum UNIT_PRICE_TYPES {
  unit = 'PER_UNIT',
  day = 'PER_DAY',
  person = 'PER_PERSON',
  group = 'PER_GROUP',
}

enum DEAL_STATUSES {
  requested = 'REQUESTED',
  approved = 'APPROVED',
  rejected = 'REJECTED',
  paid = 'PAID',
}

enum OFFER_CATEGORIES {
  checkInCheckOut = 'CHECK_IN_CHECK_OUT',
  transportation = 'TRANSPORTATION',
  fAndB = 'F_AND_B',
  seasonal = 'SEASONAL',
  family = 'FAMILY',
  romantic = 'ROMANTIC',
  healthAndSpa = 'HEALTH_AND_SPA',
  artAndCulture = 'ART_AND_CULTURE',
  activities = 'ACTIVITIES',
  services = 'SERVICES',
  propertyProtection = 'PROPERTY_PROTECTION',
  others = 'OTHERS',
}

enum OFFER_CONFIRMATION_TYPES {
  auto = 'AUTO',
  manual = 'MANUAL',
}

enum OFFER_LABELS {
  selected = 'selected',
  requested = 'requested',
}

const CATEGORIES_WITH_ADDRESS = [OFFER_CATEGORIES.others];

export {
  CATEGORIES_WITH_ADDRESS,
  OFFER_LABELS,
  UPSELLING_PAYMENTS_STATUSES,
  OFFER_TEMPLATES,
  OFFER_PRICE_TYPES,
  OFFER_PRICES_FIELD,
  UNIT_PRICE_TYPES,
  DEAL_STATUSES,
  OFFER_CATEGORIES,
  OFFER_CONFIRMATION_TYPES,
};
